module.exports = __webpack_public_path__ + "img/L_323_328.a8b65afd.png";